
import axios from "../utils/api";


/* =========================================================
   GET BOOKING PROPERTY
========================================================= */

export const getBookingProperty = async (
  subdomain
) => {

  const response =
    await axios.get(
      `/booking-engine/${subdomain}`
    );

  return response.data;
};


/* =========================================================
   GET BOOKING ROOMS
========================================================= */

export const getBookingRooms = async (
  subdomain
) => {

  const response =
    await axios.get(
      `/booking-engine/${subdomain}/rooms`
    );

  return response.data;
};


/* =========================================================
   GET ROOM AVAILABILITY
========================================================= */

export const getRoomAvailability = async ({
  subdomain,
  roomTypeId,
  checkIn,
  checkOut,
}) => {

  const response =
    await axios.get(
      `/booking-engine/${subdomain}/availability`,
      {
        params: {
          roomTypeId,
          checkIn,
          checkOut,
        },
      }
    );

  return response.data;
};


/* =========================================================
   GET PUBLIC DATE-WISE RATES
========================================================= */

export const getBookingRates = async ({
  subdomain,
  roomTypeId,
  startDate,
  endDate,
  ratePlanName = "BAR",
}) => {

  if (!subdomain) {

    throw new Error(
      "Booking subdomain is required."
    );

  }

  if (!roomTypeId) {

    throw new Error(
      "Room type ID is required."
    );

  }

  if (!startDate || !endDate) {

    throw new Error(
      "Start date and end date are required."
    );

  }

  const response =
    await axios.get(
      `/booking-engine/${subdomain}/rates`,
      {
        params: {
          roomTypeId,
          startDate,
          endDate,
          ratePlanName,
        },
      }
    );

  return response.data;
};


/* =========================================================
   CREATE BOOKING
========================================================= */

export const createBooking = async ({
  subdomain,
  bookingPayload,
}) => {

  if (!subdomain) {

    throw new Error(
      "Booking subdomain could not be determined."
    );

  }

  console.log(
    "🏨 CREATE BOOKING SUBDOMAIN:",
    subdomain
  );

  console.log(
    "📦 CREATE BOOKING PAYLOAD:",
    bookingPayload
  );

  const response =
    await axios.post(
      `/booking-engine/${subdomain}/book`,
      bookingPayload
    );

  return response.data;
};


export const getBookingOffers = async (
  subdomain
) => {

  if (!subdomain) {

    throw new Error(
      "Booking subdomain could not be determined."
    );

  }

  console.log(
    "🎁 GET PUBLIC BOOKING OFFERS:",
    subdomain
  );

  const response =
    await axios.get(
      `/booking-engine/${subdomain}/offers`
    );

  return response.data;
};


/* ======================================
   🎁 VALIDATE BOOKING OFFER

   Public endpoint:

   POST
   /booking-engine/:subdomain/offers/validate
====================================== */

export const validateBookingOffer = async ({
  subdomain,
  offerCode,
  roomTotal,
  checkIn,
  checkOut,
}) => {

  if (!subdomain) {

    throw new Error(
      "Booking subdomain could not be determined."
    );

  }

  if (!offerCode) {

    throw new Error(
      "Offer code is required."
    );

  }

  console.log(
    "🎁 VALIDATING BOOKING OFFER:",
    {
      subdomain,
      offerCode,
      roomTotal,
      checkIn,
      checkOut,
    }
  );

  const response =
    await axios.post(
      `/booking-engine/${subdomain}/offers/validate`,
      {
        offerCode,
        roomTotal,
        checkIn,
        checkOut,
      }
    );

  return response.data;
};


